module.exports = __webpack_public_path__ + "img/excel.8b754141.svg";